import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Texture, Spritesheet } from "pixi.js";
export class MyBuildingsResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("MyBuildingsResourcePackage");
    }
    public get assets_views_mybuildings_building_png(): Texture {
        return this.resource<Texture>("assets/views/mybuildings/building.png");
    }
    public get assets_views_mybuildings_scrollbar_scrollbar_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/mybuildings/scrollbar/scrollbar_1x.atlas.json");
    }
    public get assets_views_mybuildings_scrollbar_line_png(): Texture {
        return this.assets_views_mybuildings_scrollbar_scrollbar_1x_atlas_json.textures["line.png"];
    }
    public get assets_views_mybuildings_scrollbar_lift_png(): Texture {
        return this.assets_views_mybuildings_scrollbar_scrollbar_1x_atlas_json.textures["lift.png"];
    }
    public get assets_views_mybuildings_scrollbar_arrow_png(): Texture {
        return this.assets_views_mybuildings_scrollbar_scrollbar_1x_atlas_json.textures["arrow.png"];
    }
    public get assets_views_mybuildings_scrollbar_scrollbar_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/mybuildings/scrollbar/scrollbar_1x.atlas.png");
    }
    public get assets_views_mybuildings_ui_ui_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/mybuildings/ui/ui_1x.atlas.json");
    }
    public get assets_views_mybuildings_ui_building_glow_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["building_glow.png"];
    }
    public get assets_views_mybuildings_ui_next_building_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["next_building.png"];
    }
    public get assets_views_mybuildings_ui_price_history_shape_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["price_history_shape.png"];
    }
    public get assets_views_mybuildings_ui_glow_fix_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["glow_fix.png"];
    }
    public get assets_views_mybuildings_ui_glow_in_marketplace_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["glow_in_marketplace.png"];
    }
    public get assets_views_mybuildings_ui_building_road_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["building_road.png"];
    }
    public get assets_views_mybuildings_ui_upgrade_linear_gradient_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["upgrade_linear_gradient.png"];
    }
    public get assets_views_mybuildings_ui_adress_placeholder_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["adress_placeholder.png"];
    }
    public get assets_views_mybuildings_ui_fix_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["fix.png"];
    }
    public get assets_views_mybuildings_ui_locked1_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["locked1.png"];
    }
    public get assets_views_mybuildings_ui_locked2_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["locked2.png"];
    }
    public get assets_views_mybuildings_ui_Price_history_icon_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["Price_history_icon.png"];
    }
    public get assets_views_mybuildings_ui_back_button_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["back_button.png"];
    }
    public get assets_views_mybuildings_ui_upgrade_arrow_png(): Texture {
        return this.assets_views_mybuildings_ui_ui_1x_atlas_json.textures["upgrade_arrow.png"];
    }
    public get assets_views_mybuildings_ui_ui_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/mybuildings/ui/ui_1x.atlas.png");
    }
}

